import React from 'react'
import moment from 'moment'

import { financial } from '../../core/controllers/Financial';
import { multiTaskerManager } from '../../core/controllers/MultiTaskerManager'
import NavLink from '../Routes/NavLink'

export default class FinancialBreakdownWidget extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            noValue: false
        }
    }

    componentDidMount() {
        var self = this;
        financial.getFinancialStats(function(response) {
            var stats = response.data.stats;

            const total = Math.abs(stats.gross_income) + Math.abs(stats.net_income) + Math.abs(stats.expenses);

            if(total == 0) {
                self.setState({noValue: true});
                return;
            }
            const netIncomePercentage = (Math.abs(stats.net_income) / total) * 100;
            const grossIncomePercentage = (Math.abs(stats.gross_income) / total) * 100;
            const expensesPercentage = (Math.abs(stats.expenses) / total) * 100;

            var formattedNetIncome = (stats.net_income).toLocaleString('en-US', {
                style: 'currency',
                currency: 'USD',
            });

            var formattedGrossIncome = (stats.gross_income).toLocaleString('en-US', {
                style: 'currency',
                currency: 'USD',
            });

            var formattedExpenses = (stats.expenses).toLocaleString('en-US', {
                style: 'currency',
                currency: 'USD',
            });

            var data = {
                labels: ["Net Income " + formattedNetIncome, "Gross Income " + formattedGrossIncome, "Expenses " + formattedExpenses],
                series: [{
                    value: netIncomePercentage,
                    name: 'Net Income',
                    className: 'ct-slice-pie ct-series-a chart-net-income',
                    meta: 'netIncome',
                  }, {
                    value: grossIncomePercentage,
                    name: 'Gross Income',
                    className: 'ct-slice-pie ct-series-b chart-income',
                    meta: 'grossIncome',
                  }, {
                    value: expensesPercentage,
                    name: 'Expenses',
                    className: 'ct-slice-pie ct-series-c chart-expenses',
                    meta: 'expenses',
                  }]
            };

            var responsiveOptions = [
                ['screen and (min-width: 640px)', {
                    chartPadding: 10,
                    labelOffset: 10,
                    labelDirection: 'explode',
                    labelInterpolationFnc: function(value) {
                        return value;
                    }
                }],
                ['screen and (min-width: 1024px)', {
                    labelOffset: 35,
                    chartPadding: 20
                }]
            ];

            var sum = function(a, b) { return a + b };
            var chart = new Chartist.Pie('.pie-chart', data, {
                labelInterpolationFnc: function(value) {
                    return value;//Math.round(value / data.series.reduce(sum) * 100) + '%';
                }
            }, responsiveOptions);

            chart.on('created', (data) => {
                jQuery('.chart-income').on('click', self.incomeSelected.bind(event, self));
                jQuery('.chart-net-income').on('click', self.netIncomeSelected.bind(event, self));
                jQuery('.chart-expenses').on('click', self.expensesSelected.bind(event, self));
            });
        });
    }

    componentWillUpdate(nextProps, nextState) {
    }

    incomeSelected(context, event) {
        multiTaskerManager.setData({type: 'income'}, 'financialBreakdown');
        multiTaskerManager.forceUpdate();
    }

    netIncomeSelected(context, event) {
        multiTaskerManager.setData({type: 'netIncome'}, 'financialBreakdown');
        multiTaskerManager.forceUpdate();
    }

    expensesSelected(context, event) {
        multiTaskerManager.setData({type: 'expenses'}, 'financialBreakdown');
        multiTaskerManager.forceUpdate();
    }

    render(){
        return (
            <div class="col-md-4">
                <div class="card">
                    <div class="header">
                        <h4 class="title">Financial Breakdown</h4>
                        <p class="category">For the month of { moment().format('MMMM') }.</p>
                    </div>
                    <div class="content">
                        <div class="row">
                            <div class="col-md-12">
                                { this.state.noValue ? (
                                    <p>No financial information to display.</p>
                                ) : (
                                    <div class="pie-chart"></div>
                                )}
                            </div>
                        </div>
                    </div>
                    <div class="content">
                        <div class="footer">
                            <div class="legend">
                                <NavLink to={"/financial"}>
                                <button type="button" data-loading-text="Loading..." class="btn btn-info btn-fill pull-right" autoComplete="off" >
                                Go To Finances
                                </button>
                                </NavLink>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
};


// WEBPACK FOOTER //
// app/components/Financial/FinancialBreakdownWidget.jsx